const path = "./static/themes/champions-league/audio/";
export const ldcConfig = {
  intro: [
    `${path}Blur-Song2.mp3`,
    `${path}Fatboy_Slim_-_Funk_Soul_Brother.mp3`,
    `${path}Caesars_Palace_-_Jerk_It_Out_Official_Video.mp3`,
    `${path}Bloc_Party_-_Helicopter.mp3`
  ],
  win: [
    `${path}hymne-uefa.mp3`,
  ]
};
